module.exports = __webpack_public_path__ + "static/media/use-case-10.910e7914.jpg";